export const en = {
    horizontal: 'Horizontal',
    square: 'Square',
    vertical: 'Vertical'
};
